// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2b6d0adf","337":"8ffdf7e7","453":"1bd6f32f","455":"0816c060","701":"6ea401d3"}[chunkId] + ".chunk.js";
};